(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const markReady = (media) => {
    media.dataset.mediaReady = 'true';
    media.removeAttribute('data-media-failed');
  };

  const markFailed = (media) => {
    media.dataset.mediaFailed = 'true';
    media.removeAttribute('data-media-ready');
  };

  const commandYouTube = (frame, func) => {
    try {
      frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func, args: [] }), '*');
    } catch (error) {}
  };

  const forceYouTubePlayback = (frame) => {
    const run = () => {
      commandYouTube(frame, 'mute');
      commandYouTube(frame, 'playVideo');
    };
    run();
    window.setTimeout(run, 250);
    window.setTimeout(run, 900);
  };

  const activate = (media) => {
    if (!media || media.dataset.mediaActivated === 'true') return;
    media.dataset.mediaActivated = 'true';

    if (reducedMotion.matches) {
      markFailed(media);
      return;
    }

    const video = media.querySelector('video');
    const frame = media.querySelector('iframe[data-uc-video-src]');

    if (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.addEventListener('playing', () => markReady(media), { once: true });
      video.addEventListener('error', () => markFailed(media), { once: true });
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => markFailed(media));
      }
      return;
    }

    if (frame) {
      const source = frame.dataset.ucVideoSrc;
      frame.addEventListener('load', () => {
        if (source?.includes('youtube')) forceYouTubePlayback(frame);
        markReady(media);
      }, { once: true });
      frame.addEventListener('error', () => markFailed(media), { once: true });
      if (source) frame.src = source;
      return;
    }

    if (media.querySelector('.uc-media-fill__poster')) markReady(media);
    else markFailed(media);
  };

  const deactivate = (media) => {
    if (!media) return;
    const video = media.querySelector('video');
    const frame = media.querySelector('iframe[data-uc-video-src]');

    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    if (frame) frame.removeAttribute('src');

    media.removeAttribute('data-media-ready');
    media.removeAttribute('data-media-activated');
  };

  const observe = (media) => {
    if (!media) return;
    if (!('IntersectionObserver' in window)) {
      activate(media);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        activate(media);
        observer.disconnect();
      }
    }, { rootMargin: '180px 0px', threshold: 0.01 });

    observer.observe(media);
  };

  reducedMotion.addEventListener?.('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('[data-uc-autoplay-media]').forEach(deactivate);
  });

  window.UCMedia = { activate, deactivate, observe, reducedMotion };
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-uc-autoplay-media]').forEach(observe));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-uc-autoplay-media]').forEach(deactivate));
})();
